import { render, staticRenderFns } from "./UserStateChip.vue?vue&type=template&id=9336aaf6&scoped=true"
import script from "./UserStateChip.vue?vue&type=script&lang=ts"
export * from "./UserStateChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9336aaf6",
  null
  
)

export default component.exports